import { createElement } from 'react';
import { Ad } from 'components/Ad';
import { rm } from 'utils';
import { RegistryType } from 'components/Shared/Markdown';
import { Ad as AdModel } from 'models/Ad';
import { SponsoredBy } from 'components/Ad/sponsoredBy';

const createAd = (ad: AdModel) =>
  createElement(Ad, { ad, gotoOfferText: rm('ads_offer_linktext') });

export const registry = {
  'Bygghemma.Commerce.Web.Models.Ads.ImageAd': createAd,
  'Bygghemma.Commerce.Web.Models.Ads.LeaderBoardAd': createAd,
  'Bygghemma.Commerce.Web.Models.Ads.MediumAd': createAd,
  'Bygghemma.Commerce.Web.Models.Ads.RedAd': createAd,
  'Bygghemma.Commerce.Web.Models.Ads.SiteWideAd': createAd,
  'Bygghemma.Commerce.Web.Models.Ads.SliderAd': createAd,
  'Bygghemma.Commerce.Web.Models.Ads.TakeoverAd': createAd,
  'Bygghemma.Commerce.Web.Models.Ads.Ad': (ad: AdModel) =>
    createElement(Ad, { ad, gotoOfferText: rm('ads_offer_linktext') }),
  'Bygghemma.Commerce.Web.Models.SponsoredBy': SponsoredBy
} as RegistryType;
